import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from "@mui/material";

import { Trans } from "@lingui/macro";
import { BillingTableProps } from "./models";

export class BillingTable extends React.Component<BillingTableProps, {}>
{

  private handlePaymentMethod = () => {
    if (this.props.subscription?.default_payment_method) {
      return "default_p_m"
    }

    if (this.props.subscription?.default_source) {
      return "default source"
    }
  }

  render() {
    return (<Table sx={{ mt: 10 }}>
      <TableBody>
        <TableRow>
          <TableCell sx={{ border: 0, width: "200px" }}>
            <Typography variant="h3" sx={{ color: "#FFFFFF", fontSize: "20px", textTransform: "uppercase", textAlign: "center", background: process.env.REACT_APP_PRIMARY_COLOR }}><Trans id="bt-table-cell-subscription">Fatturazione</Trans></Typography>
          </TableCell>
          <TableCell sx={{ border: 0, width: "300px" }} />
          <TableCell sx={{ border: 0, width: "500px" }}>
            <Typography variant="h3" sx={{ color: "#FFFFFF" }}><Trans id="pt-table-cell-billing-date">Data di fatturazione</Trans></Typography>
          </TableCell>
          <TableCell sx={{ border: 0 }}>
            <Typography variant="body2" sx={{ color: "#D9D9D9" }}>{new Date(this.props.subscription?.billing_cycle_anchor! * 1000).toLocaleDateString("it-IT")}</Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>)
  }
}
